import React, { useEffect, useState } from "react";
import { AppFrame, TopBar, BottomNav } from "@/components/Shell";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminSettings() {
  const [form, setForm] = useState({ whatsapp_number: "", store_name: "", store_tagline: "", public_url: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/settings");
      setForm({
        whatsapp_number: data.whatsapp_number || "",
        store_name: data.store_name || "",
        store_tagline: data.store_tagline || "",
        public_url: data.public_url || "",
      });
    })();
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      // Normalise the URL — strip trailing slash, add https:// if missing
      let pu = (form.public_url || "").trim();
      if (pu && !/^https?:\/\//i.test(pu)) pu = "https://" + pu;
      pu = pu.replace(/\/+$/, "");
      await api.put("/settings", { ...form, public_url: pu || null });
      setForm((f) => ({ ...f, public_url: pu }));
      toast.success("Saved");
    } catch { toast.error("Save failed"); }
    finally { setSaving(false); }
  };

  return (
    <AppFrame>
      <TopBar title="Settings" subtitle="Store" />
      <div className="px-5 mt-4 space-y-4">
        <div>
          <label className="text-[10px] uppercase tracking-[0.2em] text-neutral-500">WhatsApp number (with country code)</label>
          <input
            data-testid="setting-wa-number"
            value={form.whatsapp_number}
            onChange={(e) => setForm({ ...form, whatsapp_number: e.target.value })}
            placeholder="+919876543210"
            className="mt-1 w-full h-12 rounded-2xl border border-black/10 px-4 text-sm outline-none focus:border-neutral-900"
          />
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-[0.2em] text-neutral-500">Store name</label>
          <input
            data-testid="setting-store-name"
            value={form.store_name}
            onChange={(e) => setForm({ ...form, store_name: e.target.value })}
            className="mt-1 w-full h-12 rounded-2xl border border-black/10 px-4 text-sm outline-none focus:border-neutral-900"
          />
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-[0.2em] text-neutral-500">Tagline</label>
          <input
            data-testid="setting-tagline"
            value={form.store_tagline}
            onChange={(e) => setForm({ ...form, store_tagline: e.target.value })}
            className="mt-1 w-full h-12 rounded-2xl border border-black/10 px-4 text-sm outline-none focus:border-neutral-900"
          />
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-[0.2em] text-neutral-500">Public share domain</label>
          <input
            data-testid="setting-public-url"
            value={form.public_url}
            onChange={(e) => setForm({ ...form, public_url: e.target.value })}
            placeholder="www.bbalod.com"
            inputMode="url"
            autoCapitalize="none"
            className="mt-1 w-full h-12 rounded-2xl border border-black/10 px-4 text-sm outline-none focus:border-neutral-900"
          />
          <p className="text-[11px] mt-1 text-neutral-500">
            When set, all share links (products, categories, shop QR) will use this domain instead of the URL you're currently browsing.
          </p>
        </div>
        <button
          data-testid="save-settings-btn"
          onClick={save} disabled={saving}
          className="w-full h-12 rounded-full bg-neutral-900 text-white text-sm font-medium press"
        >
          {saving ? "Saving..." : "Save settings"}
        </button>
      </div>
      <BottomNav />
    </AppFrame>
  );
}
